export const AssignmentStatus = {
    DRAFT: 'DRAFT',
    READY: 'READY',
    APPROVED: 'APPROVED',
};
/** Значення в порядку оголошення в схемі. */
export const ASSIGNMENT_STATUS_VALUES = ['DRAFT', 'READY', 'APPROVED'];
export const ASSIGNMENT_STATUS_LABELS = {
    DRAFT: 'Чернетка',
    READY: 'Готово',
    APPROVED: 'Погоджено',
};
export const ASSIGNMENT_STATUS_TONES = {
    DRAFT: 'neutral',
    READY: 'info',
    APPROVED: 'success',
};
//# sourceMappingURL=assignment-status.js.map